import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

/**
 * Protege las rutas del Portal del cliente (/portal/*, Fase 19): requiere
 * sesión activa Y que el usuario tenga clientId (usuario de portal). Un
 * usuario interno (personal de la firma) que intente entrar aquí se
 * redirige a /dashboard — el backend además rechaza esa combinación a
 * nivel de API (NOT_A_PORTAL_USER) si lo intenta vía llamadas directas.
 */
export default function PortalProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!user?.clientId) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
